<template lang="pug">
  main#main.organization-contact
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-comment-dots')
      section.l-section
        .l-section-h
          b-row.mb-5
            b-col
              router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'organization-contact',
  components: {
    WcBreadcrumb,
  },
}
</script>
